import campaignOrderJson from "./campaignOrder.json";
import campaignsJson from "./campaigns.json";
import {ICampaign} from "../models/campaign";

export const campaignOrder: Array<string> = campaignOrderJson;
export const campaigns: Record<string, ICampaign> = campaignsJson;
